module.exports = __webpack_public_path__ + "static/img/yiling-hospital-management.f0e902f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/yiling-hospital-management.png
// module id = yIlA
// module chunks = 1 2